/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InvoiceSimpleDto { 
    id?: number;
    insertTs?: string;
    amountRequested?: number;
    amountPaid?: number;
    currency?: InvoiceSimpleDto.CurrencyEnum;
    invoiceDate?: string;
    paid?: boolean;
    fakturaInvoiceId?: string;
    creditCardFee?: number;
    vatRate?: number;
    porto?: number;
}
export namespace InvoiceSimpleDto {
    export const CurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];
}


